import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { whatsappLink } from "@/lib/dtf";
import { WHATSAPP_DISPLAY } from "@/config/dtf";

const WhatsAppIcon = ({ className = "" }) => (
  <svg viewBox="0 0 32 32" aria-hidden="true" className={className} fill="currentColor">
    <path d="M16.04 4C9.96 4 5 8.93 5 15c0 2.13.61 4.11 1.67 5.79L5 28l7.4-1.63A11.1 11.1 0 0 0 16.04 26C22.12 26 27 21.07 27 15S22.12 4 16.04 4Zm0 19.8c-1.7 0-3.28-.5-4.6-1.35l-.33-.2-3.9.86.85-3.78-.22-.34A8.72 8.72 0 0 1 7.2 15c0-4.85 3.96-8.8 8.84-8.8 4.87 0 8.76 3.95 8.76 8.8s-3.89 8.8-8.76 8.8Zm5.02-6.56c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.13-.42-2.16-1.33-.8-.71-1.33-1.58-1.49-1.85-.16-.27-.02-.42.12-.56.13-.13.27-.32.4-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.83-2.01-.22-.52-.44-.45-.61-.46h-.52c-.18 0-.47.07-.72.34-.25.27-.95.92-.95 2.25s.97 2.61 1.11 2.79c.14.18 1.9 3.02 4.62 4.12 2.72 1.1 2.72.73 3.21.69.49-.05 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32Z" />
  </svg>
);

export const FloatingWhatsApp = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.7, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 right-4 z-40 flex flex-col items-end gap-2 sm:bottom-7 sm:right-7"
        >
          <span className="hidden rounded-full border border-neutral-200 bg-white px-4 py-2 text-xs font-bold text-black shadow-lg sm:block">
            Envie sua arte agora
          </span>
          <a
            href={whatsappLink(
              "Olá! Vim pelo ClickDTF e gostaria de encomendar minha impressão DTF têxtil.",
            )}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Envie sua arte agora pelo WhatsApp"
            title={`WhatsApp ${WHATSAPP_DISPLAY}`}
            data-testid="floating-whatsapp-button"
            className="wa-ring relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25d366] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.9)] transition-transform duration-200 hover:scale-105 sm:h-16 sm:w-16"
          >
            <WhatsAppIcon className="h-7 w-7 sm:h-8 sm:w-8" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
